var $ = require('jquery');
var magnificPopup = require('magnific-popup');

function init() {
	var $anchor = $('.howCanWeHelpTrigger');
	if(!$anchor.length)
		return;

	$anchor.magnificPopup({
		mainClass: 'mfp-wrap--custom',
		items: {
			src: $('.howCanWeHelpLightbox'),
			type: 'inline',
		}
	});
}

module.exports = {
	init: init
};
